import {Injectable, signal} from '@angular/core';

export type ViewMode = 'admin' | 'dozent' | 'teilnehmer';

const STORAGE_KEY = 'freymut-view-mode';

@Injectable({providedIn: 'root'})
export class ViewModeService {
    private _mode = signal<ViewMode>(this.loadMode());

    readonly mode = this._mode.asReadonly();

    get isDozentMode(): boolean {
        return this._mode() === 'dozent';
    }

    get isAdminMode(): boolean {
        return this._mode() === 'admin';
    }

    get isTeilnehmerMode(): boolean {
        return this._mode() === 'teilnehmer';
    }

    setMode(mode: ViewMode): void {
        this._mode.set(mode);
        localStorage.setItem(STORAGE_KEY, mode);
    }

    toggle(): void {
        this.setMode(this._mode() === 'admin' ? 'dozent' : 'admin');
    }

    private loadMode(): ViewMode {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === 'dozent' || stored === 'teilnehmer') return stored;
        return 'admin';
    }
}
